export const logActivity = async (userId, activity, page, Api) => {
  try {

    const response = await fetch(`${Api}/api/activity-log`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId, activity, page }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Response error:", errorData);
      throw new Error("Failed to log activity");
    }

    
  } catch (err) {
    console.error("Activity log error:", err.message);
  }
};

export const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to fetch IP address:", error);
    return "IP not found"; // Fallback in case of failure
  }
};
